import { ReactElement, useMemo, memo } from 'react';
import { Marker } from 'react-map-gl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruckFast as VehicleIcon } from '@fortawesome/free-solid-svg-icons';

import { MarkerDeliveryVehicleProps } from './types';
import {
  MarkerDeliveryVehicleContainer,
  MarkerDeliveryVehicleChip,
  MarkerDeliveryVehicleArrow,
} from './styles';

const MarkerDeliveryVehicle = ({
  vehicleName,
  vehicleColor,
  driverName,
  ...restMarkerWrapperProps
}: MarkerDeliveryVehicleProps): ReactElement => {
  const label = useMemo(() => {
    let output = vehicleName;

    if (driverName) output += ` / ${driverName}`;

    return output;
  }, [driverName, vehicleName]);

  return (
    <Marker {...restMarkerWrapperProps}>
      <MarkerDeliveryVehicleContainer>
        <MarkerDeliveryVehicleChip
          label={label}
          icon={
            <FontAwesomeIcon
              icon={VehicleIcon}
              style={{ color: vehicleColor }}
            />
          }
        />

        <MarkerDeliveryVehicleArrow />
      </MarkerDeliveryVehicleContainer>
    </Marker>
  );
};

export default memo(MarkerDeliveryVehicle);
